import React from 'react';
import { motion } from 'framer-motion';

const SlideTwo = () => {
    return (
        <motion.section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="h-screen w-full flex items-center justify-center px-6 md:px-40 lg:px-40 relative"
        >
            <div className="max-w-7xl mx-auto text-black px-2 md:px-0">
                <h1 className="text-3xl md:p-0 -sm:text-3xl md:text-[7vh] lg:text-[7vh] font-open font-bold leading-snug md:tracking-tighter sm:leading-tight md:leading-tight lg:leading-tight mb-8">
                    <span className="text-3xl md:text-6xl font-bebas font-bold">“</span>
                    The power to control our species’
                    genetic future is awesome and terrifying.
                    Deciding how to handle it may be the
                    biggest challenge we have ever faced.
                    <span className="text-3xl md:text-6xl font-bebas">”</span>
                </h1>

                <p className="mt-6 md:mt-10 text-base md:text-lg  md:p-0 ">
                    <span className="text-red-600 text-3xl md:text-4xl font-bebas font-bold uppercase tracking-wide">
                        Jennifer A. Doudna,
                    </span>{' '}
                    <br></br>
                    <span className="uppercase text-3xl md:text-4xl font-bold font-bebas  tracking-wide">
                        Co-Discoverer of CRISPR, 2020 Nobel Laureate
                    </span>
                </p>

                {/* Arrow */}
                <div className="absolute bottom-10 right-6 text-2xl">↓</div>
            </div>
        </motion.section>
    );
};

export default SlideTwo;